import React, { useReducer, useMemo, createContext } from 'react'
import { AnalyticsContext, analyticsReducer, useAnalyticsContext, useAnalyticsDashboard } from 'AnalyticsDashboard/AnalyticsContext'
import Filters from 'AnalyticsDashboard/components/Filters'

export default function AnalyticsProvider({
  children,
  uiEnabled = true,
  filterValues = {}
}) {
  const [state, dispatch] = useReducer(analyticsReducer, {
    queriesInfo: [],
    queriesInfoLoaded: false,
    queries: {},
    filterValues,
    uiEnabled,
    local: {
      loading: true
    }
  })

  const value = useMemo(() => ({ state, dispatch }), [state])

  return (
    <AnalyticsContext.Provider value={value}>
      <div className="analytics-dashboard">
        { uiEnabled && <Filters /> }
        <AnalyticsContainer>
          {children}
        </AnalyticsContainer>
      </div>
    </AnalyticsContext.Provider>
  )
}


function AnalyticsContainer({ children }) {
  const { fetchQueriesInfo } = useAnalyticsDashboard()
  const queriesInfoLoaded = useAnalyticsContext().state.queriesInfoLoaded

  useEffect(() => {
    fetchQueriesInfo()
  }, [])

  if (!queriesInfoLoaded) return null

  return <>
    { children }
  </>
}
